import React from 'react';

const Search = ({aboutRef}) => {
  return (
    <div className='max-w-[1240px] mx-auto lg:grid-cols-1 gap-4 px-4 pb-16 text-center'>
      <div className='lg:col-span-2 flex flex-col justify-evenly'>
        <div>
          <h2 ref={aboutRef}>Private Trip</h2>
          <p className='py-4'>
          Bali is a province of Indonesia and the westernmost of the Lesser Sunda Islands. East of Java and west of Lombok,
          the province includes the island of Bali and a few smaller neighbouring islands, notably Nusa Penida, Nusa Lembongan, and Nusa Ceningan.
          </p>
        </div>
      </div>

    </div>
  );
};

export default Search;
